import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _getNextTransitionRequest = {};
var _getNextTransitionResponse = {};
var _initFlowContextRequest = {};
var _initFlowContextResponse = {};
function resolveWixApiFunnelBuilderV2FlowJourneyServiceUrl(opts) {
    var domainToMappings = {
        'www._base_domain_': [
            {
                srcPath: '/_api/funnel-builder-service',
                destPath: '',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/funnel-builder-service',
                destPath: '',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/funnel-builder-service',
                destPath: '',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/funnel-builder-service',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/funnel-builder-service',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * This method should be called at the beginning of the flow. It creates an empty
 * flow context or restores it from url path which has encoded answers in it
 * in case user opened the flow somewhere in the middle
 */
export function initFlowContext(payload) {
    var _a = serializer(_initFlowContextRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_initFlowContextResponse, {}).fromJSON;
    function __initFlowContext(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.funnel_builder.v2.flow_context',
            method: 'POST',
            methodFqn: 'wix.api.funnel.builder.v2.FlowJourneyService.InitFlowContext',
            url: resolveWixApiFunnelBuilderV2FlowJourneyServiceUrl({
                protoPath: '/v2/flow/context',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __initFlowContext.fromReq = fromReq;
    __initFlowContext.__isAmbassador = true;
    return __initFlowContext;
}
/**
 * Returns details of the next page which should be displayed in the flow
 * based on flow context information
 */
export function getNextTransition(payload) {
    var _a = serializer(_getNextTransitionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getNextTransitionResponse, {}).fromJSON;
    function __getNextTransition(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.funnel_builder.v2.flow_context',
            method: 'POST',
            methodFqn: 'wix.api.funnel.builder.v2.FlowJourneyService.GetNextTransition',
            url: resolveWixApiFunnelBuilderV2FlowJourneyServiceUrl({
                protoPath: '/v2/flow/transitions/next',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getNextTransition.fromReq = fromReq;
    __getNextTransition.__isAmbassador = true;
    return __getNextTransition;
}
//# sourceMappingURL=http.impl.js.map